import { useState, useMemo } from "react";
import { Checkbox, FormControlLabel, FormGroup } from "@material-ui/core";
import { FExtrasCheckboxesStyles } from "./styles";

export const parseExtrasFromHTML = (htmlString, extrasList) => {
  if (!htmlString) return [];

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  const items = Array.from(doc.querySelectorAll("li")).map(li => 
    li.textContent.split(":")[0].trim()
  );

  return extrasList
    .filter(extra => items.includes(extra.nombre))
    .map(extra => extra.id);
};

export const convertExtrasToHTML = (extrasIds, extrasList, isIncluded = true) => {
  const filteredExtras = extrasList.filter(extra => 
    isIncluded 
      ? extrasIds.includes(extra.id)
      : !extrasIds.includes(extra.id)
  );

  if (filteredExtras.length === 0) {
    return `<p><strong>${isIncluded ? 'Incluye' : 'No Incluye'}</strong></p>`;
  }

  const itemsHTML = filteredExtras
    .map(extra => `<li>${extra.nombre}: ${extra.descripcion}</li>`)
    .join("");

  return `<ul>${itemsHTML}</ul>`;
};

export const normalizarExtras = (extrasList = []) => {
  return extrasList.map((extra) => ({
    id: extra.IdCatPaqueteAditamento || extra.IdCatVueloAditamento || extra.id,
    nombre: extra.Nombre || extra.nombre,
    descripcion: extra.Descripcion || extra.descripcion
  }));
};

const ExtrasCheckboxes = ({
  extrasList = [],
  selectedIds = [],
  onSelectionChange
}) => {
  const classes = FExtrasCheckboxesStyles();
  const [localSelectedIds, setLocalSelectedIds] = useState(selectedIds);
  
  // Determinar si estamos en modo controlado o no
  const isControlled = selectedIds !== undefined && onSelectionChange;
  const currentSelectedIds = isControlled ? selectedIds : localSelectedIds;

  const selectedExtrasMap = useMemo(() => {
    return new Set(currentSelectedIds);
  }, [currentSelectedIds]);

  const handleCheckboxChange = (id) => {
    const newSelectedIds = selectedExtrasMap.has(id)
      ? currentSelectedIds.filter(item => item !== id)
      : [...currentSelectedIds, id];

    if (isControlled) {
      onSelectionChange(newSelectedIds);
    } else {
      setLocalSelectedIds(newSelectedIds);
    }
  };

  return (
    <FormGroup className={classes.formGroup}>
      {extrasList.map((extra) => (
        <FormControlLabel
          key={extra.id}
          label={extra.nombre}
          control={
            <Checkbox
              checked={selectedExtrasMap.has(extra.id)}
              onChange={() => handleCheckboxChange(extra.id)}
              color="primary"
            />
          }
        />
      ))}
    </FormGroup>
  );
};

export default ExtrasCheckboxes;